<div class="highlighted-container container">
    <div class="row">
        <div class="highlighted">  
            <div class="region region-highlighted">
                <h1 class="page-header">
                    <span>{{ 'REQUEST_EMAIL_CHANGE_HEADING' | translate }}</span>
                </h1>
            </div>
        </div>
    </div>
</div>

<div class="main-container container">
    <section class="col-sm-2"></section>
    <section class="col-sm-8">
        <div class="region region-content">
            <form class="custom-from" #customForm="ngForm" (ngSubmit)="submitForm(customForm)" novalidate>
                <div style="margin-bottom: 25px;"><p>{{ 'REQUEST_EMAIL_CHANGE_VALIDATION_TITLE' | translate }}</p></div>
                <div class="row">
                    <section class="col-sm-6 lb"><label class="star">*</label>{{ 'REQUEST_EMAIL_CHANGE_VALIDATION_CODE' | translate }}</section>
                    <section class="col-sm-6">
                        <input type="text" 
                            class="form-control" 
                            id="emailValidationCode" name="emailValidationCode" 
                            [(ngModel)]="request.emailValidationCode"   
                            [ngClass]="{ 'is-invalid': formSubmitted && customForm.controls.emailValidationCode.errors }"
                            [disabled]="numberOfAttempts==5"
                            placeholder="{{ 'COMMON_LBL_REQUIRED' | translate }}"                                             
                            required maxlength="10"/>
                        <div *ngIf="formSubmitted && !isValidCode" class="text-danger">{{ 'REQUEST_EMAIL_CHANGE_VALIDATION_ERR_INVALID_CODE' | translate }}</div>
                        <div *ngIf="numberOfAttempts==5" class="text-danger">{{ 'REQUEST_EMAIL_CHANGE_VALIDATION_ERR_MAX_ATTEMPT' | translate }}</div>
                    </section>
                </div>
                <div *ngIf="formSubmitted && customForm.invalid" class="row" style="margin: auto;">
                    <div class="col-sm-12 error-note">
                        <label translate="COMMON_LBL_FORM_ERR_NOTE"></label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6"></div>
                    <div class="col-md-6">
                        <button type="submit" class="btn btn-secondary action-row" [disabled]="numberOfAttempts==5">{{ 'COMMON_BTN_SUBMIT' | translate }}</button>
                    </div>
                </div>
            </form>
        </div>
    </section>
    <section class="col-sm-2"></section>
</div>    
